// Module
var code = "<offer-list\n  show-actions=\"true\"\n  show-status=\"true\"\n  listing-id=\"$ctrl.listingId\"\n></offer-list>\n";
// Exports
module.exports = code;